export const GET_TEMPLATES_REQUEST = 'GET_TEMPLATES_REQUEST';
export const GET_GROUP_TEMPLATE_REQUEST = 'GET_GROUP_TEMPLATE_REQUEST';
export const GET_PROJECT_TEMPLATE_REQUEST = 'GET_PROJECT_TEMPLATE_REQUEST';
export const GET_TASK_TEMPLATE_REQUEST = 'GET_TASK_TEMPLATE_REQUEST';
export const GET_CHECKLIST_TEMPLATE_REQUEST = 'GET_CHECKLIST_TEMPLATE_REQUEST';
export const CREATE_CHECKLIST_TEMPLATE_REQUEST = 'CREATE_CHECKLIST_TEMPLATE_REQUEST';
export const UPDATE_CHECKLIST_TEMPLATE_REQUEST = 'UPDATE_CHECKLIST_TEMPLATE_REQUEST';
export const DELETE_CHECKLIST_TEMPLATE_REQUEST = 'DELETE_CHECKLIST_TEMPLATE_REQUEST';
export const GET_QUOTE_TEMPLATE_REQUEST = 'GET_QUOTE_TEMPLATE_REQUEST';
export const CREATE_QUOTE_TEMPLATE_REQUEST = 'CREATE_QUOTE_TEMPLATE_REQUEST';
export const UPDATE_QUOTE_TEMPLATE_REQUEST = 'UPDATE_QUOTE_TEMPLATE_REQUEST';
export const DELETE_QUOTE_TEMPLATE_REQUEST = 'DELETE_QUOTE_TEMPLATE_REQUEST';
export const CREATE_QUOTE_TEMPLATE_FROM_QUOTE_REQUEST = 'CREATE_QUOTE_TEMPLATE_FROM_QUOTE_REQUEST';
export const CREATE_GROUP_TEMPLATE_REQUEST = 'CREATE_GROUP_TEMPLATE_REQUEST';
export const CREATE_PROJECT_TEMPLATE_REQUEST = 'CREATE_PROJECT_TEMPLATE_REQUEST';
export const CREATE_TASK_TEMPLATE_REQUEST = 'CREATE_TASK_TEMPLATE_REQUEST';
export const UPDATE_GROUP_TEMPLATE_REQUEST = 'UPDATE_GROUP_TEMPLATE_REQUEST';
export const UPDATE_PROJECT_TEMPLATE_REQUEST = 'UPDATE_PROJECT_TEMPLATE_REQUEST';
export const UPDATE_TASK_TEMPLATE_REQUEST = 'UPDATE_TASK_TEMPLATE_REQUEST';
export const DELETE_GROUP_TEMPLATE_REQUEST = 'DELETE_GROUP_TEMPLATE_REQUEST';
export const DELETE_PROJECT_TEMPLATE_REQUEST = 'DELETE_PROJECT_TEMPLATE_REQUEST';
export const DELETE_TASK_TEMPLATE_REQUEST = 'DELETE_TASK_TEMPLATE_REQUEST';
export const EXECUTE_GROUP_TEMPLATE_REQUEST = 'EXECUTE_GROUP_TEMPLATE_REQUEST';
export const EXECUTE_PROJECT_TEMPLATE_REQUEST = 'EXECUTE_PROJECT_TEMPLATE_REQUEST';
export const GET_TEMPLATE_IMPORT_SOURCE_REQUEST = 'GET_TEMPLATE_IMPORT_SOURCE_REQUEST';
export const IMPORT_TEMPLATE_REQUEST = 'IMPORT_TEMPLATE_REQUEST';

export const getTemplates = (type, start, limit, callback) => ({
    type: GET_TEMPLATES_REQUEST,
    payload: { type, start, limit, callback }
});

export const getGroupTemplate = (templateId, callback) => ({
    type: GET_GROUP_TEMPLATE_REQUEST,
    payload: { templateId, callback }
});

export const getProjectTemplate = (templateId, callback) => ({
    type: GET_PROJECT_TEMPLATE_REQUEST,
    payload: { templateId, callback }
});

export const getTaskTemplate = (templateId, callback) => ({
    type: GET_TASK_TEMPLATE_REQUEST,
    payload: { templateId, callback }
});

export const getChecklistTemplate = (templateId, callback) => ({
    type: GET_CHECKLIST_TEMPLATE_REQUEST,
    payload: { templateId, callback }
});

export const createChecklistTemplate = (templateData, callback) => ({
    type: CREATE_CHECKLIST_TEMPLATE_REQUEST,
    payload: { templateData, callback }
});

export const updateChecklistTemplate = (templateId, templateData, callback) => ({
    type: UPDATE_CHECKLIST_TEMPLATE_REQUEST,
    payload: { templateId, templateData, callback }
});

export const deleteChecklistTemplate = (templateId, callback) => ({
    type: DELETE_CHECKLIST_TEMPLATE_REQUEST,
    payload: { templateId, callback }
});

export const getQuoteTemplate = (templateId, callback) => ({
    type: GET_QUOTE_TEMPLATE_REQUEST,
    payload: { templateId, callback }
});

export const createQuoteTemplate = (templateData, callback) => ({
    type: CREATE_QUOTE_TEMPLATE_REQUEST,
    payload: { templateData, callback }
});

export const updateQuoteTemplate = (templateId, templateData, callback) => ({
    type: UPDATE_QUOTE_TEMPLATE_REQUEST,
    payload: { templateId, templateData, callback }
});

export const deleteQuoteTemplate = (templateId, callback) => ({
    type: DELETE_QUOTE_TEMPLATE_REQUEST,
    payload: { templateId, callback }
});

export const createQuoteTemplateFromQuote = (quoteId, data, callback) => ({
    type: CREATE_QUOTE_TEMPLATE_FROM_QUOTE_REQUEST,
    payload: { quoteId, data, callback }
});

export const createGroupTemplate = (templateData, callback) => ({
    type: CREATE_GROUP_TEMPLATE_REQUEST,
    payload: { templateData, callback }
});

export const createProjectTemplate = (templateData, callback) => ({
    type: CREATE_PROJECT_TEMPLATE_REQUEST,
    payload: { templateData, callback }
});

export const createTaskTemplate = (templateData, callback) => ({
    type: CREATE_TASK_TEMPLATE_REQUEST,
    payload: { templateData, callback }
});

export const updateGroupTemplate = (templateId, templateData, callback) => ({
    type: UPDATE_GROUP_TEMPLATE_REQUEST,
    payload: { templateId, templateData, callback }
});

export const updateProjectTemplate = (templateId, templateData, callback) => ({
    type: UPDATE_PROJECT_TEMPLATE_REQUEST,
    payload: { templateId, templateData, callback }
});

export const updateTaskTemplate = (templateId, templateData, callback) => ({
    type: UPDATE_TASK_TEMPLATE_REQUEST,
    payload: { templateId, templateData, callback }
});

export const deleteGroupTemplate = (templateId, callback) => ({
    type: DELETE_GROUP_TEMPLATE_REQUEST,
    payload: { templateId, callback }
});

export const deleteProjectTemplate = (templateId, callback) => ({
    type: DELETE_PROJECT_TEMPLATE_REQUEST,
    payload: { templateId, callback }
});

export const deleteTaskTemplate = (templateId, callback) => ({
    type: DELETE_TASK_TEMPLATE_REQUEST,
    payload: { templateId, callback }
});

export const executeGroupTemplate = (templateId, options, callback) => ({
    type: EXECUTE_GROUP_TEMPLATE_REQUEST,
    payload: { templateId, options, callback }
});

export const executeProjectTemplate = (templateId, options, callback) => ({
    type: EXECUTE_PROJECT_TEMPLATE_REQUEST,
    payload: { templateId, options, callback }
});

export const getTemplateImportSource = (sourceType, sourceId, callback) => ({
    type: GET_TEMPLATE_IMPORT_SOURCE_REQUEST,
    payload: { sourceType, sourceId, callback }
});

export const importTemplate = (payload, callback) => ({
    type: IMPORT_TEMPLATE_REQUEST,
    payload: { ...payload, callback }
});
